export default __webpack_public_path__ + "static/leg_img_3-6d773d2175dce2a9a93f2f362e2af6c3.png";